import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";

import { map, catchError } from "rxjs/operators";
import { domain } from "src/environments/environment";
import { GlobalProvider } from "./global";

@Injectable({
  providedIn: "root",
})
export class AuthService {
  constructor(private http: HttpClient, private g: GlobalProvider) {}
  getHeader = () => {
    return {
      headers: new HttpHeaders({
        Authorization: this.g.jws,
      }),
    };
  };

  login(username, password) {
    const httpOptions = {
      headers: new HttpHeaders({
        // Authorization: this.jws ? this.jws : ''
      }),
    };
    const url = `${domain}/access/login`;
    const data = { username, password };
    return this.http.post(url, { data }, httpOptions).pipe(
      map((results) => results),
      catchError((error) => {
        // console.log('login', error);
        throw error;
      })
    );
  }


 signInProvider(data:any) {
    const url = `${domain}/access/signInProvider`;
    return this.http.post(url, { data }).pipe(
      map((results) => results),
      catchError((error) => {
        // console.log('login', error);
        throw error;
      })
    );
  }

  async loginViaToken(jws) {
    const httpOptions = {
      headers: new HttpHeaders({
        Authorization: jws,
      }),
    };
    const url = `${domain}/access/profile`;
    return this.http.get(url, httpOptions).pipe(
      map((results) => {
        // console.log('loginViaToken return ok', results);
        return results;
      }),
      catchError((error) => {
        // console.log('loginViaToken', error);
        throw error;
      })
    );
  }
  async loginViaSSO(sso) {
    const httpOptions = {
      headers: new HttpHeaders({}),
    };
    const options = { ...httpOptions, params: { sso } };
    const url = `${domain}/access/sso`;
    return this.http.get(url, options).pipe(
      map((results) => {
        // console.log('loginViaToken return ok', results);
        return results;
      }),
      catchError((error) => {
        // console.log('loginViaToken', error);
        throw error;
      })
    );
  }
  async forgetPassword(companyId, username, mobile) {
    const url = `${domain}/public/forgetPassword`;
    const data = {
      data: {
        companyId,
        username,
        mobile,
      },
    };
    return this.http.post(url, data).pipe(
      map((results) => results),
      catchError((error) => {
        throw error;
      })
    );
  }
  async forgetPasswordReset(email, otp, password) {
    const url = `${domain}/public/forgetPasswordReset`;
    const data = {
      data: {
        email,
        otp,
        password,
      },
    };
    return this.http.post(url, data).pipe(
      map((results) => results),
      catchError((error) => {
        throw error;
      })
    );
  }
}
